export const GET_GROUPS_PHASE = "GET_GROUPS_PHASE";